"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _reactReduxI18n = require("react-redux-i18n");

var _documents = require("../../../utils/documents");

var _DocumentVersionActions = _interopRequireDefault(require("../documentVersion/DocumentVersionActions"));

var _DocumentState = _interopRequireDefault(require("../state/DocumentState"));

var _strings = require("../../../utils/strings");

var _DocumentDossierChips = _interopRequireDefault(require("../../DocumentDossierChips"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _jsxRuntime = require("react/jsx-runtime");

function DocumentDetailsHeader(props) {
  var _props$document = props.document,
      additionalDesignation = _props$document.additionalDesignation,
      certifyingThirdParty = _props$document.certifyingThirdParty,
      workerFirstName = _props$document.workerFirstName,
      workerLastName = _props$document.workerLastName;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "row align-items-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "col-xl-8 flex-container space-between font-size-s",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
            className: "inline-container",
            children: [props.hasCollectionMandateEnabled && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
                title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactReduxI18n.Translate, {
                  value: "document.documentDetails.documentIsGathered.".concat(props.document.type.country)
                }),
                placement: "right",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "flex-container information",
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
                    icon: "drawer"
                  })
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
              "data-id": "document-title",
              children: props.document.type.name
            })]
          }), !(0, _strings.isEmpty)(certifyingThirdParty) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "separator information",
            children: certifyingThirdParty
          }), !(0, _strings.isEmpty)(workerFirstName) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "separator information",
            children: "".concat(workerLastName, " ").concat(workerFirstName)
          }), !(0, _strings.isEmpty)(additionalDesignation) && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "separator information",
            children: additionalDesignation
          })]
        }), !(0, _strings.isEmpty)(props.dossiers) && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "mr-5",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentDossierChips.default, {
            dossiers: props.dossiers
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "col-xl-4 flex-container space-between",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentState.default, {
          document: props.document
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "flex-container",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DocumentVersionActions.default, {
            document: props.document,
            documentActions: props.documentActions,
            documentPermissions: props.documentPermissions,
            showUpdate: props.showUpdate,
            forHeader: true
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "caret-".concat(props.isOpen ? 'raise' : 'drop')
          })]
        })]
      })]
    }), props.message]
  });
}

DocumentDetailsHeader.propTypes = {
  document: (0, _documents.documentVersionPropTypes)().isRequired,
  documentPermissions: (0, _documents.documentPermissionsPropTypes)().isRequired,
  documentActions: (0, _documents.documentActionsPropTypes)().isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  message: _propTypes.default.node,
  showUpdate: _propTypes.default.bool.isRequired,
  dossiers: _propTypes.default.array,
  hasCollectionMandateEnabled: _propTypes.default.bool.isRequired
};
var _default = DocumentDetailsHeader;
exports.default = _default;
//# sourceMappingURL=DocumentDetailsHeader.js.map